import * as React from 'react'

import { cn } from '../../lib/utils'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-muted rounded-md animate-pulse', className)}
      {...props}
    />
  )
}

/**
 * Os d'une valeur en chargement, en ligne dans son texte (`<span>`, valide dans un `<p>` ou un
 * titre) : hauteur tirée de la police (0,72 em), largeur du texte attendu (`width`, en `ch`).
 * L'interligne ne change pas : la ligne a la même hauteur chargée ou non.
 */
function Bone({
  width,
  className,
  style,
  ...props
}: React.ComponentProps<'span'> & { width: string }) {
  return (
    <span
      data-slot="skeleton"
      aria-hidden
      className={cn(
        'bg-muted inline-block h-[0.72em] rounded-sm align-middle animate-pulse',
        className,
      )}
      style={{ width, ...style }}
      {...props}
    />
  )
}

export { Bone, Skeleton }
